// Shared "last updated" date for all legal pages.
// Update this single value whenever you revise any legal document; every
// legal page (Privacy, Terms, Disclaimer, Accessibility) will pick it up.
export const LEGAL_LAST_UPDATED = "16 August 2026";
